var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _HttpClient_instances, _HttpClient_props, _HttpClient_createRequest, _HttpClient_getAadHttpClient;
import { useState } from 'react';
import { HttpStatusCode } from '../utilities';
export class HttpClient {
    constructor(props) {
        _HttpClient_instances.add(this);
        _HttpClient_props.set(this, void 0);
        this.usePut = (options) => {
            const [result, setResult] = useState();
            const [isLoading, setIsLoading] = useState(false);
            const [isError, setIsError] = useState(false);
            const executor = (data) => {
                const processRequestAsync = async () => {
                    try {
                        const apiUrl = options.apiUrl();
                        const [client, url] = await __classPrivateFieldGet(this, _HttpClient_getAadHttpClient, "f").call(this, apiUrl);
                        const result = await client.put(url, __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_createRequest).call(this, 'PUT', JSON.stringify(data)));
                        setResult(result);
                        setIsLoading(false);
                        setResult(result);
                    }
                    catch (error) {
                        setIsError(true);
                    }
                };
                processRequestAsync();
            };
            const res = { isLoading, isError, value: result, ref: executor };
            return res;
        };
        _HttpClient_getAadHttpClient.set(this, async (apiUrl) => {
            apiUrl = apiUrl.trim();
            while (apiUrl.startsWith('/'))
                apiUrl = apiUrl.substring(1);
            const url = apiUrl.startsWith('https://') || apiUrl.startsWith('http://') ? apiUrl : `${__classPrivateFieldGet(this, _HttpClient_props, "f").baseUrl}/${apiUrl}`;
            const client = {
                get: async (url, options) => {
                    var _a, _b;
                    const accessToken = await ((_b = (_a = __classPrivateFieldGet(this, _HttpClient_props, "f").auth).getAccessToken) === null || _b === void 0 ? void 0 : _b.call(_a, __classPrivateFieldGet(this, _HttpClient_props, "f").module));
                    if (options.headers == null)
                        options.headers = {};
                    options.headers['authorization'] = 'Bearer ' + accessToken;
                    return fetch(url, options);
                },
                post: async (url, options) => {
                    var _a, _b;
                    const accessToken = await ((_b = (_a = __classPrivateFieldGet(this, _HttpClient_props, "f").auth).getAccessToken) === null || _b === void 0 ? void 0 : _b.call(_a, __classPrivateFieldGet(this, _HttpClient_props, "f").module));
                    if (options.headers == null)
                        options.headers = {};
                    options.headers['authorization'] = 'Bearer ' + accessToken;
                    return fetch(url, Object.assign(Object.assign({}, options), { method: 'POST' }));
                },
                put: async (url, options) => {
                    var _a, _b;
                    const accessToken = await ((_b = (_a = __classPrivateFieldGet(this, _HttpClient_props, "f").auth).getAccessToken) === null || _b === void 0 ? void 0 : _b.call(_a, __classPrivateFieldGet(this, _HttpClient_props, "f").module));
                    if (options.headers == null)
                        options.headers = {};
                    options.headers['authorization'] = 'Bearer ' + accessToken;
                    return fetch(url, Object.assign(Object.assign({}, options), { method: 'PUT' }));
                },
                delete: async (url, options) => {
                    var _a, _b;
                    const accessToken = await ((_b = (_a = __classPrivateFieldGet(this, _HttpClient_props, "f").auth).getAccessToken) === null || _b === void 0 ? void 0 : _b.call(_a, __classPrivateFieldGet(this, _HttpClient_props, "f").module));
                    if (options.headers == null)
                        options.headers = {};
                    options.headers['authorization'] = 'Bearer ' + accessToken;
                    return fetch(url, Object.assign(Object.assign({}, options), { method: 'DELETE' }));
                },
            };
            return [client, url];
        });
        __classPrivateFieldSet(this, _HttpClient_props, props, "f");
    }
    async aadGetJson(apiUrl) {
        const [client, url] = await __classPrivateFieldGet(this, _HttpClient_getAadHttpClient, "f").call(this, apiUrl);
        return new Promise(async (resolve, reject) => {
            try {
                const response = await client.get(url, __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_createRequest).call(this, 'GET'));
                if (response.ok) {
                    resolve(response.json());
                }
                else {
                    if (response.status === 404) {
                        reject({ ExceptionMessage: 'API no encontrada' });
                    }
                    else {
                        const err = await response.json();
                        this._writeException(err);
                        reject(err);
                    }
                }
            }
            catch (ex) {
                reject(ex);
            }
        });
    }
    async aadGetArrayBuffer(apiUrl) {
        const [client, url] = await __classPrivateFieldGet(this, _HttpClient_getAadHttpClient, "f").call(this, apiUrl);
        return new Promise(async (resolve, reject) => {
            try {
                const response = await client.get(url, __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_createRequest).call(this, 'GET'));
                if (response.ok) {
                    resolve(response.blob());
                }
                else {
                    const err = await response.json();
                    this._writeException(err);
                    reject(err);
                }
            }
            catch (ex) {
                reject({
                    ExceptionMessage: `Error de comunicación con el servidor. ${ex.message}`
                });
            }
        });
    }
    async aadGetText(apiUrl) {
        const [client, url] = await __classPrivateFieldGet(this, _HttpClient_getAadHttpClient, "f").call(this, apiUrl);
        return new Promise(async (resolve, reject) => {
            try {
                const response = await client.get(url, __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_createRequest).call(this, 'GET'));
                if (response.ok) {
                    resolve(response.text());
                }
                else {
                    const err = await response.json();
                    this._writeException(err);
                    reject(err);
                }
            }
            catch (ex) {
                reject({
                    ExceptionMessage: `Error de comunicación con el servidor. ${ex.message}`
                });
            }
        });
    }
    async aadPost(apiUrl, data) {
        const [client, url] = await __classPrivateFieldGet(this, _HttpClient_getAadHttpClient, "f").call(this, apiUrl);
        return new Promise(async (resolve, reject) => {
            try {
                const response = await client.post(url, __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_createRequest).call(this, 'POST', JSON.stringify(data)));
                if (response.ok) {
                    this._processResponse(response, 'json', resolve);
                }
                else {
                    const err = await response.json();
                    this._writeException(err);
                    reject(err);
                }
            }
            catch (ex) {
                reject({
                    ExceptionMessage: `Error de comunicación con el servidor. ${ex.message}`
                });
            }
        });
    }
    async aadPostFormData(apiUrl, data) {
        const [client, url] = await __classPrivateFieldGet(this, _HttpClient_getAadHttpClient, "f").call(this, apiUrl);
        return new Promise(async (resolve, reject) => {
            try {
                const response = await client.post(url, __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_createRequest).call(this, 'POST', data));
                if (response.ok) {
                    if (response.status === 204) {
                        resolve(null);
                    }
                    else {
                        resolve(response.json());
                    }
                }
                else {
                    const err = await response.json();
                    this._writeException(err);
                    reject(err);
                }
            }
            catch (ex) {
                reject({
                    ExceptionMessage: `Error de comunicación con el servidor. ${ex.message}`
                });
            }
        });
    }
    async aadPostArrayBuffer(apiUrl, data) {
        const [client, url] = await __classPrivateFieldGet(this, _HttpClient_getAadHttpClient, "f").call(this, apiUrl);
        return new Promise(async (resolve, reject) => {
            try {
                const response = await client.post(url, __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_createRequest).call(this, 'POST', JSON.stringify(data)));
                if (response.ok) {
                    resolve(response.blob());
                }
                else {
                    const err = await response.json();
                    this._writeException(err);
                    reject(err);
                }
            }
            catch (ex) {
                reject(ex);
            }
        });
    }
    async aadPut(apiUrl, data) {
        const [client, url] = await __classPrivateFieldGet(this, _HttpClient_getAadHttpClient, "f").call(this, apiUrl);
        return new Promise(async (resolve, reject) => {
            try {
                const response = await client.put(url, __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_createRequest).call(this, 'PUT', JSON.stringify(data)));
                if (response.ok) {
                    resolve(response.json());
                }
                else {
                    const err = await response.json();
                    this._writeException(err);
                    reject(err);
                }
            }
            catch (ex) {
                reject({
                    ExceptionMessage: `Error de comunicación con el servidor. ${ex.message}`
                });
            }
        });
    }
    async aadDelete(apiUrl) {
        const [client, url] = await __classPrivateFieldGet(this, _HttpClient_getAadHttpClient, "f").call(this, apiUrl);
        return new Promise(async (resolve, reject) => {
            try {
                const options = __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_createRequest).call(this, 'DELETE');
                const response = await client.delete(url, options);
                if (response.ok) {
                    resolve();
                }
                else {
                    const err = await response.json();
                    this._writeException(err);
                    reject(err);
                }
            }
            catch (ex) {
                reject({
                    ExceptionMessage: `Error de comunicación con el servidor. ${ex.message}`
                });
            }
        });
    }
    parseDicionary(url, filters) {
        if (filters !== void 0) {
            const processedFilters = [];
            for (const filter in filters) {
                if (Object.prototype.hasOwnProperty.call(filters, filter)) {
                    const value = filters[filter];
                    processedFilters.push(`filters[${filter}]=${value}`);
                }
            }
            if (url.indexOf('?') >= 0) {
                url += '&' + processedFilters.join('&');
            }
            else {
                url += '?' + processedFilters.join('&');
            }
        }
        return url;
    }
    _writeException(err) {
        console.log(`Message: ${err.Message}`);
        console.log(`ExceptionType: ${err.ExceptionType}`);
        console.log(`ExceptionMessage: ${err.ExceptionMessage || err.exceptionMessage}`);
        console.log(`StackTrace: ${err.StackTrace}`);
    }
    _processResponse(response, type, resolve) {
        const processOK = () => {
            switch (type) {
                case 'json':
                    resolve(response.json());
                    break;
                case 'binary':
                    resolve(response.blob());
                    break;
                case 'text':
                    break;
                case 'empty':
                    break;
                default: throw new Error('Invalid type: ' + type);
            }
        };
        switch (response.status) {
            case HttpStatusCode.OK:
            case HttpStatusCode.Created:
                processOK();
                break;
            case HttpStatusCode.NoContent:
                resolve(null);
                break;
            case HttpStatusCode.PartialContent:
                resolve(null);
                break;
            default:
                break;
        }
    }
}
_HttpClient_props = new WeakMap(), _HttpClient_getAadHttpClient = new WeakMap(), _HttpClient_instances = new WeakSet(), _HttpClient_createRequest = function _HttpClient_createRequest(method, body) {
    var _a, _b, _c, _d;
    const props = __classPrivateFieldGet(this, _HttpClient_props, "f");
    const apimKey = (_b = (_a = props.auth) === null || _a === void 0 ? void 0 : _a.getApimKey) === null || _b === void 0 ? void 0 : _b.call(_a, props.module);
    const customHeaders = (_d = (_c = props.auth) === null || _c === void 0 ? void 0 : _c.getHeaders) === null || _d === void 0 ? void 0 : _d.call(_c, props.module);
    return {
        headers: Object.assign({ 'Accept': 'application/json', 'Content-Type': 'application/json', 'Ocp-Apim-Subscription-Key': apimKey }, customHeaders),
        method,
        body
    };
};
